import React from 'react';

import GoogleDeskImg from '../assets/images/scene-desk.jpg';
import GoogleCafeImg from '../assets/images/scene-cafe.jpg';
import GoogleCommuteImg from '../assets/images/scene-commute.jpg';

import PixelPhone from '../assets/images/pixel-phone.png';
import PixelImage1 from '../assets/images/slide-1_website_en.jpg';
import PixelImage2 from '../assets/images/slide-2_website_en.jpg';
import PixelImage3 from '../assets/images/slide-3_website_en.jpg';
import ImageFrame from '../assets/svg/ImageFrame';

import { Controller, Scene } from 'react-scrollmagic';

const PresentationSliding = () => (
  // @TODO - Maybe change this div to section and fix if there are breaking changes.
  <div id="presentation-sliding">
    <div className="presentation-container">
      <div
        className="title text-center"
        data-sal="fade"
        data-sal-delay="400"
        data-sal-duration="1100"
        data-sal-easing="ease"
      >
        <h2>Groundbreaking new app, available now!</h2>
      </div>

      <Controller>
        <Scene triggerElement="#presentation-sliding" triggerHook="onLeave" pin duration={1700} pinSettings={ {pushFollowers: false}} >
          <div className="device-frame">
            <div className="device-wrapper">
              <div className="spacer"></div>
              <img
                src={PixelPhone}
                alt="PixelPhone"
                className="pixel-phone"
              ></img>
            </div>
          </div>
        </Scene>
        <Scene triggerElement="#presentation-sliding" triggerHook="onLeave" pin duration={1700} pinSettings={ {pushFollowers: false}} >
          <div className="image-frame">
            <div className="image-wrapper">
              <img src={PixelImage3} alt="PixelImage" className="app-image"></img>
            </div>
          </div>
        </Scene>
        <Scene triggerElement="#presentation-sliding" triggerHook="onLeave" pin duration={1000} pinSettings={ {pushFollowers: false}} >
          <div className="image-frame">
            <div className="image-wrapper">
              <img src={PixelImage2} alt="PixelImage" className="app-image"></img>
            </div>
          </div>
        </Scene>
        <Scene triggerElement="#presentation-sliding" triggerHook="onLeave" pin duration={300} pinSettings={ {pushFollowers: false}}>
          <div className="image-frame">
            <div className="image-wrapper">
              <img src={PixelImage1} alt="PixelImage"></img>
            </div>
          </div>
        </Scene>
      </Controller>

      <div
        className="content-row row-1 left"
        data-sal="slide-right"
        data-sal-delay="400"
        data-sal-duration="1100"
        data-sal-easing="ease"
      >
        <div className="content-image">
          <ImageFrame />
          <img src={GoogleDeskImg} alt="image"></img>
        </div>
      </div>
      <div
        className="content-row row-1 right"
        data-sal="slide-left"
        data-sal-delay="400"
        data-sal-duration="1100"
        data-sal-easing="ease"
      >
        <div className="content-text">
          <h2>Lorem ipsum</h2>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Expedita
            amet, omnis blanditiis temporibus nam aperiam odit assumenda facilis
            doloribus? Deleniti illo quisquam eaque animi sunt nobis deserunt
            rerum eligendi fuga?
        </p>
        </div>
      </div>
      <div
        className="content-row row-2 left"
        data-sal="slide-right"
        data-sal-delay="400"
        data-sal-duration="1100"
        data-sal-easing="ease"
      >
        <div className="content-text">
          <h2>Lorem ipsum</h2>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Expedita
            amet, omnis blanditiis temporibus nam aperiam odit assumenda facilis
            doloribus? Deleniti illo quisquam eaque animi sunt nobis deserunt
            rerum eligendi fuga?
        </p>
        </div>
      </div>
      <div
        className="content-row row-2 right"
        data-sal="slide-left"
        data-sal-delay="400"
        data-sal-duration="1100"
        data-sal-easing="ease"
      >
        <div className="content-image">
          <ImageFrame />
          <img src={GoogleCafeImg} alt="image"></img>
        </div>
      </div>

      <div
        className="content-row row-3 left"
        data-sal="slide-right"
        data-sal-delay="400"
        data-sal-duration="1100"
        data-sal-easing="ease"
      >
        <div className="content-image">
          <ImageFrame />
          <img src={GoogleCommuteImg} alt="image"></img>
        </div>
      </div>
      <div
        className="content-row row-3 right"
        data-sal="slide-left"
        data-sal-delay="400"
        data-sal-duration="1100"
        data-sal-easing="ease"
      >
        <div className="content-text">
          <h2>Lorem ipsum</h2>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Expedita
            amet, omnis blanditiis temporibus nam aperiam odit assumenda facilis
            doloribus? Deleniti illo quisquam eaque animi sunt nobis deserunt
            rerum eligendi fuga?
        </p>
        </div>
      </div>
    </div>
  </div>
)


export default PresentationSliding;
